export const Endpoint = 'chat/edit-message';
export const Method = 'GET';
